import './img/page-load-1.gif';
import './loader.scss'

$(window).load(function(){
  if ($(".page-loader").length) {
    $(".page-loader").fadeOut(800);
  }
});


// WEBPACK FOOTER //
// ./resources/views/partials/index/loader/loader.js